import { UiApiCrudClientBaseV1 } from '../crud-client-base'
import type {
  IFilter,
  IFilterCreateRequest,
  IFilterDelRequest,
  IFilterGetManyRequest,
  IFilterGetRequest,
  IFilterPutRequest,
  IGetRelevantFilterRequest,
} from '../../../types'

const BASE_PATH = '/v1/filters'

export class FilterUiApiClientV1 extends UiApiCrudClientBaseV1<IFilter> {
  create = async (request: IFilterCreateRequest) =>
    this.restPost<IFilter>(BASE_PATH, request.filter)

  get = async (request: IFilterGetRequest) =>
    this.restGet<IFilter>(`${BASE_PATH}/${request.uid}`)

  put = async (request: IFilterPutRequest) =>
    this.mergeAndPut(BASE_PATH, request.filter)

  del = async (request: IFilterDelRequest) =>
    this.restDelete(`${BASE_PATH}/${request.uid}`)

  getMany = async (request: IFilterGetManyRequest) => {
    const { limit, page, name, resourceId, ...rest } = request as Record<
      string,
      unknown
    >
    const queryParams = this.buildQueryParams({
      limit,
      page,
      name,
      resourceId,
      ...rest,
    })
    const response = await this.restGet<{ items: IFilter[] }>(
      BASE_PATH,
      queryParams,
    )
    if (!response.items) throw new Error('Invalid response: missing "items"')
    return response.items.map((item) => this.getItem(item))
  }

  public getItem(filter: IFilter) {
    const { uid, name } = filter
    if (!uid || !name) {
      throw Error('Invalid response')
    }
    return { ...filter, uid, name }
  }

  public async getRelevant(request: IGetRelevantFilterRequest) {
    return this.restGet<IFilter>(`${BASE_PATH}/relevant`, {
      resourceId: request.resourceId,
    })
  }
}
